
var main_num;
var model_num;
var year_num;
var product_add = {
  "warranty": "",
  "trapofix": "",
  "trapoeco": "",
  "classic_plus": "",
  "trapo_back": "",
  "vid": ""
};

var product_confirm =  {
  "Title": "",
  "Trapo Back": "",
  "Classic Plus": "",
  "Trapo Fix": "",
  "Trapo Eco": "",
  "Warranty": ""
}

var product_confirmation_price = {
  "Trapo Back": "",
  "Classic Plus": "",
  "Trapo Fix": "",
  "Trapo Eco": "",
  "Warranty": ""
}
var buyTrapoBack = false;
var mat_carousel;
var $template;
var variant_option;
var _sku;

var brand = {
  "num" : "",
  "href": ""
};
var model = {
  "num" : "",
  "href": ""
};
var year = {
  "num" : "",
  "href": ""
};

$(function(){
  $template = $('#js_template').val();

  // Global function call
  findSecondButtonBindEvent();

  if ($template.includes('product')) {
    toggleSelect();
    bindDropdownWithSwatch();
    bindCheckScroll();
    $("select.transmission_dropdown").each(function () {
      $(this).val($(this).find('option[selected]').val());
    });

    if (!(window.location.href).toString().includes('?variant=')) {
      var $carousel = $('.js-product-gallery').flickity();
      $carousel.flickity( 'select', 0)
    }
  }

  if ($template.includes('search')) {
    searchTemplateDisplay();
  }

  $('.mini_cart').on('click', function(){
    window.location.href="/cart";
  })

  // click to hide/show accordion
  $('.question_info').on('click',function(){
    $this = $(this);
    $this.parent().parent().find('.info-label').fadeToggle().css('display', 'block');
    if ($(window).width() >= 799) {
      $('.mobile-div').remove();
    }
    else{
      $('.desktop-div').remove();
    }
  })

    if ($template.includes('index')) {
      setTimeout(() => $('.cocoen').cocoen(), 2000);
    }

  // Accordion
  var allPanels = $('.accordion > dd').hide();

  $('.accordion > dt > a').click(function() {
    if(!$(this).parent().next().is(":visible")) {
     $(this).parent().find('small.right').html('&#9660;');
     $(this).parent().next().slideDown();
    } else if($(this).parent().next().is(":visible")){
      $(this).parent().next().slideUp();
      $(this).parent().next('.accordion small.right').html('&#9658;');
      $(this).next('small.right').html('&#9658;');
      if($(this).find('small.right').html('&#9660;')) {
        $(this).find('small.right').html('&#9658;');
      } else if($(this).find('small.right').html('&#9658;')) {
        $(this).find('small.right').html('&#9660;');
      }
    }
        return false;
  });

  if (document.getElementById("description_accordion_arrow")) {
    document.getElementById("description_accordion_arrow").click();
  }

  if (document.getElementById("tc_accordion_arrow")) {
    document.getElementById("tc_accordion_arrow").click();
  }


  openFixandClassicPlusMoreInfo();

  if ($template.includes("cart")) {
    checkCartAddon();
    setTimeout(() => $('.slider-gallery').flickity('resize'), 5500);
  }
})


checkCartAddon = () => {
  var _mainproduct = 0;
  $.getJSON('/cart.js', function(cart) {
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].product_type != "TRAPO CLASSIC" && cart.items[i].product_type != "TRAPO HEX" && cart.items[i].product_type != "TRAPO ECO" && cart.items[i].product_type != "TRAPO EXTRA BAGASI"  && cart.items[i].product_type != "TRAPO BACK CLASSIC" && cart.items[i].product_type != "TRAPO OXTRA"){
        _mainproduct += 1;
      }
    }

    console.log(_mainproduct, cart.items.length);
    if (_mainproduct == cart.items.length && cart.items.length != 0) {
     // CartJS.clear();
      setTimeout(function(){
        // location.reload();
      },1000)
    }
  })
}

openFixandClassicPlusMoreInfo = () => {
  console.log('hello');
  if($(window).width() > 500) {
    //$('.desk-extrainfo').show();
    //$('.mobile-extrainfo').hide();
  }
  else{
    //$('.mobile-extrainfo').show();
    //$('.desk-extrainfo').hide();
  }

}

// Window onload function -- Can uncomment if necessary
$(window).on("load",function(){
  $('.gif-loader').fadeOut();
})

bindDropdownWithSwatch = () => {
  $('.transmission_dropdown').on('change', function(){
    var _ = $(this).val();
    console.log($('label.swatch-'+_), _);
    $('label.swatch-'+_).click();
    // variant image function
    imageUpdater(true);
  })
}

changeFixPrice = (evt) => {
  var $this = evt;
  var _pricing =$this.data('pricing');
  var _price = $this.attr('data-price');
  var _cprice = $this.attr('data-cp');
  var _compareatprice = $this.attr('data-compareprice');
  console.log(_cprice, parseFloat(_cprice), _compareatprice);
  var _length = $('.trapofix-swatch.selected').length;
  //var _length = $('.trapoeco-swatch.selected').length;
  if (_length == 0) {
    $('.main-price').show().addClass('inline');
    $('.sub-price').hide().removeClass('inline');
    $('.fixsub_was_price').hide();
  }
  else{
    console.log('HI');
    $('.main-price').hide().removeClass('inline');
    parseFloat(_price) <= 0 ? $('.sub-price').text(_pricing).removeClass('inline').hide() : $('.sub-price').text(_pricing).show().addClass('inline');

    parseFloat(_cprice) <= 0 ? $('.fixsub_was_price').hide() : $('.fixsub_was_price').text(_compareatprice).show();
  }

}

changeClassicPlusPrice = (evt) => {
  var $this = evt;
  var _pricing =$this.data('pricing');
  var _length = $('.classic-plus-swatch.selected').length;
  var _cprice = $this.attr('data-cp');
  var _compareatprice = $this.attr('data-compareprice');
  if (_length == 0) {
    $('.main-cp-price').show().addClass('inline');
    $('.sub-cp-price').hide().removeClass('inline');
    $('.sub_cp-was_price').hide();
  }
  else{
    $('.main-cp-price').hide().removeClass('inline');
    $('.sub-cp-price').text(_pricing).show().addClass('inline');

      parseFloat(_cprice) <= 0 ? $('.sub_cp-was_price').hide() : $('.sub_cp-was_price').text(_compareatprice).show();
  }
}

searchTemplateDisplay = () => {
  var _type = sessionStorage.getItem('collection_title');
  $('.'+_type).show();
}

showYTModal = (div_name) => {
  $('#yt_modal').show();
  $('.all-vid').hide();
  $('.'+div_name+'-vid').show();
}

hideYTModal = () => {
  $('#yt_modal').hide();
}

cartAddCart = (id) => {
  CartJS.addItem(id);
  setTimeout(() => location.reload(), 1000);
}

packData = (items) => {
  var new_data = [];
  var _currentHandle = $('#collection_handle').val();
  // Dont't show specific collection and addons
  for (var i = 0; i < items.results.length; i++) {
    var toAdd = false;
    for (var j = 0; j < items.results[i]['collections'].length; j++) {
      if (items.results[i]['collections'][j]['handle'] == _currentHandle)
        if (toAdd == false) {
          new_data.push(items.results[i]);
          toAdd = true;
        }
    }
  }

  return new_data;
}

bindCheckScroll = () => {
  // Initial state
  var scrollPos = 0;
  // adding scroll event

  window.addEventListener('scroll', function(){
    var scrollLeft = $(window).scrollLeft() ;
    var scrollTop = $(window).scrollTop() ;
    // detects new state and compares it with the new one
    if ((document.body.getBoundingClientRect()).top > scrollPos)
      $(window).width() < 1025 ? $('.mobile-sticky-price').fadeOut() : $('.sticky-price').fadeOut()
  	else {
      if ($(window).width() < 1025) {
        if (scrollTop > 50) {
          $('.mobile-sticky-price').fadeIn();
        }
      }
      else {
        $('.sticky-price').fadeIn();
      }
    }


  	scrollPos = (document.body.getBoundingClientRect()).top;
  });
}

checkSelectedVariant = () => {
  var _id = $('#product_selected').val();
  if ((window.location.href).toString().includes('?variant=')) {
    console.log('yo true');
    _id = (((window.location.href).toString().split('?'))[1].split('='))[1];
  }

  product_add['vid'] = _id;
}

removeProduct = (evt) => {
  // NProgress.start();
  var _cart;
  var _bundleid = ($(evt).data('bundleid')).toString().split(',');
  var _currentid = $(evt).data('id');
  var _currentkey = $(evt).data('key');
  var _backid = $(evt).data('backid');
  var _prodtype = $(evt).data('prodtype');
  var _Property = {};

  // Call cart json
  $.getJSON('/cart.js', function(cart) {
    _cart = cart;

    console.log('_bundleid', _bundleid);

    for (var i = 0; i < _cart.items.length; i++) {
      for (var j = 0; j < _bundleid.length; j++) {
        if (_bundleid[j] != "") {
          if (cart.items[i].id == _bundleid[j]) {
            _Property[cart.items[i].key] = cart.items[i].quantity - 1;
          }

          if (_prodtype == 'TRAPO EXTRA BAGASI') {
            if (cart.items[i].key == _currentkey && !_Property[_currentkey] &&  cart.items[i].properties['combo'] != 'yes') {
              _Property[cart.items[i].key] = cart.items[i].quantity-1
              // CartJS.updateItem(i+1, cart.items[i].quantity-1);
            }
          }
          else{
            if (cart.items[i].key == _currentkey && !_Property[_currentkey]) {
              _Property[cart.items[i].key] = cart.items[i].quantity - 1;
            }
          }
        }

      }

      if (_backid == cart.items[i].id && cart.items[i].properties['combo'] == 'yes') {
        // CartJS.updateItem(i+1, cart.items[i].quantity-1);
        _Property[cart.items[i].key] = cart.items[i].quantity-1
      }

      if (_bundleid.length == 1) {
        if (_bundleid[0] == "") {
          if (cart.items[i].key == _currentkey && !_Property[_currentkey]) {
            _Property[cart.items[i].key] = cart.items[i].quantity - 1;
          }
        }
      }
    }




    console.log(_Property);
    CartJS.updateItemQuantitiesById(_Property);

    setTimeout(() => {
      // NProgress.done();
      location.reload()
    }, 2000);
  });
}



findSecondButtonBindEvent = () => {
  $('.second_button').each(function(){
    var $this = $(this);
    var _text = ($this.text()).toLowerCase();
    if (_text.includes('customise it')) {
      $this.addClass('cursor');
      $this.on('click touchstart',function(){
        toggleOverlayBody();
      })
    }
  })
}

toggleOverlayBody = () =>{
  $('.overlay-body').toggle();
}

nextPrevStep = (div) => {
 var current_step = $(event.currentTarget).attr('data-steps');
 var index = $(event.currentTarget).data('index');
 var _text = $(event.currentTarget).text().toLowerCase();
 var _noback = $('#noback').val();
 var _checktype = $('#js_product_type').val();
 $('.'+div).show();
 $('.'+current_step).hide();

 index == 1 || index == 2 ? $('.new-info').show() : $('.new-info').hide() ;

 if ($(event.currentTarget).hasClass('is-next')) {
   // If trapo back add two steps
   _noback == 'true' && current_step == "product_form_step" ?  next(index+1,index+2) : next(index,index+1) ;
 }
 else if ($(event.currentTarget).hasClass('is-previous')) {
   // If trapo back minus two steps
   if (_checktype.includes('trapo hex') || _checktype.includes('trapo eco')) {
     _noback == 'true' && (current_step == "confirmation")?  next(index-3,index-2) : next(index-2,index-1);
   }
   else {
     _noback == 'true' && (current_step == "classic-plus")?  next(index-3,index-2) : next(index-2,index-1);
   }

 }

 // Build confirmation page
 var _isHexEco = index == 2 && current_step == "trapo-back";
 var _noBackHexEco = $('.isBack').val();

 if (_noBackHexEco) {
   buildConfirmation();
 }
 if ($(event.currentTarget).hasClass('is-next') && (_isHexEco || current_step == 'warranty' )) {
   buildConfirmation();
 }
}

// Num1 is always show
// Num2 is always hide
function next(num1, num2) {
  $('.progress-step').removeClass('is-active is-complete');
  for (var i = 1; i <= num1; i++) {
    $('#step'+i).addClass('is-complete');
  }

  $('#step'+num2).addClass('is-active');
}


toggleSelect = () => {
  $('.combo_addons img.not-swatch').each(function(){
    $(this).on('click', function(){
      $(this).toggleClass('selected');
      var _item = $(this).data('item');
      if (_item == 'trapo_back'){
        changeWarrantyLabelPrice($(this));
      }
      calculatePackagePrice();
    })
  })

  $('.trapofix-swatch').each(function(){
    $(this).on('click', function(){
      $(this).siblings().removeClass('selected');
      $(this).toggleClass('selected');
      calculatePackagePrice();
      changeFixPrice($(this));
    })
  })
  
  $('.trapoeco-swatch').each(function(){
    $(this).on('click', function(){
      $(this).siblings().removeClass('selected');
      $(this).toggleClass('selected');
      calculatePackagePrice();
      changeFixPrice($(this));
    })
  })

  $('.pvc-swatch').each(function(){
    $(this).on('click', function(){
      var _val = $(this).attr('data-value');
      $(this).siblings().removeClass('selected');
      $(this).toggleClass('selected');

      (_val == "Ya" && $(this).hasClass('selected')) || $('.pvc-swatch.selected').length == 0  ? pvcTrapoFix(true) : pvcTrapoFix(false)  ;
    })
  })

  $('.texture-swatch').each(function(){
    $(this).on('click', function(){
      var _val = $(this).attr('data-value');
      $(this).siblings().removeClass('selected');
      $(this).toggleClass('selected');

      (_val == "Ya" && $(this).hasClass('selected')) || $('.texture-swatch.selected').length == 0  ? pvcTrapoFix(true) : pvcTrapoFix(false)  ;
    })
  })

  $('.classic-plus-swatch').each(function(){
    $(this).on('click', function(){
      $(this).siblings().removeClass('selected');
      $(this).toggleClass('selected');
      calculatePackagePrice();
      changeClassicPlusPrice($(this));
    })
  })
}

pvcTrapoFix = (disabled_trapofix) => {
  // console.log('disabled_trapofix', disabled_trapofix);

  if (disabled_trapofix) {
    $('.trapofix-swatch.selected').click();
    //$('.trapo_fix_addons').addClass('disabled');
    $('.trapo-fixprice').addClass('d-none-force');
    // $('.trapofix-swatch').removeClass('selected');
    calculatePackagePrice();
  }
  else{

    $('.trapo-fixprice').removeClass('d-none-force');
    //$('.trapo_fix_addons').removeClass('disabled');
    // $('.trapo_2_baris').click();
    calculatePackagePrice();
  }


}

changeWarrantyLabelPrice = (element) => {
  element.hasClass('selected') ? buyTrapoBack = true : buyTrapoBack = false;
  var _wo = checkWarranty(element);
  if (_wo) {
    if (_wo != "" && _wo != "underfined")
      $('.warranty_pricing').text(Shopify.formatMoney(_wo.data('price'), $('body').data('money-format')));
  }

}

toggle360 = () => {
  $('.turntable').toggle();
  $('.js-product-gallery.product_gallery').toggle();
  $('.turntable').css('display') == 'none' ? $('.button-360').text('360 images') : $('.button-360').text('More Images');
  if ($('.js-product-gallery.product_gallery').css('display') != 'none') {
    setTimeout(function(){
      imageUpdater(true);
    },500);
  }
}

calculatePackagePrice = () => {
  // get main price

  var main_price = parseInt($('.mat_customise_money').attr('data-price'));
  var package_was_price = parseInt($('.package_was_price').attr('data-price'));
  // main_price = parseInt(main_price.replace(/[ ,.]/g, ""));
  // $('.customise_money').attr('data-price', main_price);

  $('.combo_addons img.selected').each(function(){
    var $this = $(this);
    var _p = $this.data('price');
    var _item = $this.data('item');
    var warranty_object = _item == "warranty" ? checkWarranty($this) : "";

    warranty_object == "" ? main_price += _p : main_price += warranty_object.data('price');
    if (package_was_price != "0") {
      _p1 = $this.data('cp');
      // console.log(_p1, 'here');
      warranty_object == "" ? package_was_price += _p1 : package_was_price += warranty_object.data('price');
    }

  })


  $('.trapofix-swatch.selected').each(function(){
    var _p = $(this).data('price');
    var _p1 = $(this).data('cp');
    main_price += _p;
    if (package_was_price != "0") {
      package_was_price += _p1;
    }
  })
  
  $('.trapoeco-swatch.selected').each(function(){
    var _p = $(this).data('price');
    var _p1 = $(this).data('cp');
    main_price += _p;
    if (package_was_price != "0") {
      package_was_price += _p1;
    }
  })

  $('.classic-plus-swatch.selected').each(function(){
    var _p = $(this).data('price');
    var _p1 = $(this).data('cp');
    main_price += _p;

    if (package_was_price != "0") {
      package_was_price += _p1;
    }

  })


  main_price = Shopify.formatMoney(main_price, $('body').data('money-format'))
  package_was_price = Shopify.formatMoney(package_was_price, $('body').data('money-format'))
  $('.customise_money .money').text(main_price);
  if (package_was_price != "0") {
    $('.package_was_price').text(package_was_price);
  }
}

addAll = () => {
  product_add['warranty'] = "";
  product_add['trapofix'] = "";
  product_add['classic_plus'] = "";
  product_add['trapo_back'] = "";
  product_add['trapoeco'] = "";

  var _appendid = '';
  var _mainitem = '';
  var _steps = $(event.currentTarget).data('steps');
  var _trapofixprice = 0;
  var _trapoecoprice = 0;
  var _warrantyprice = 0;
  var _classicplusprice = 0;

  var _trapofix_vtitle = "";
  var _classicplus_vtitle = "";
  var _trapoeco_vtitle = "";

  // checkSelectedVariant();
  if ($('.trapofix-swatch.selected').length != 0) {
    _trapofixprice = $('.trapofix-swatch.selected').data('pricing'); // Trapo fix breakdown price at cart page
    _trapofix_vtitle  = $('.trapofix-swatch.selected').data('title'); // Trapo fix breakdown price at cart page
    product_add['trapofix']=$('.trapofix-swatch.selected').data('id');
    _appendid += product_add['trapofix'] + ",";
    _mainitem += "Trapo Fix,";
  }
  
  if ($('.trapoeco-swatch.selected').length != 0) {
    _trapoecoprice = $('.trapoeco-swatch.selected').data('pricing'); // Trapo fix breakdown price at cart page
    _trapoeco_vtitle  = $('.trapoeco-swatch.selected').data('title'); // Trapo fix breakdown price at cart page
    product_add['trapoeco']=$('.trapoeco-swatch.selected').data('id');
    _appendid += product_add['trapoeco'] + ",";
    _mainitem += "Trapo Eco Duo,";
  }

  if ($('.classic-plus-swatch.selected').length != 0) {
    _classicplusprice = $('.classic-plus-swatch.selected').data('pricing'); // Trapo fix breakdown price at cart page
    _classicplus_vtitle = $('.classic-plus-swatch.selected').data('title'); // Trapo fix breakdown price at cart page
    product_add['classic_plus']=$('.classic-plus-swatch.selected').data('id');
    _appendid += product_add['classic_plus'] + ",";
    _mainitem += "Classic Plus,";
  }

  var _length = $('.combo_addons img.selected').length - 1;
  $('.combo_addons img.selected').each(function(index){
    var _item = $(this).data('item');
    if (_item == 'trapo_back') {
      buyTrapoBack = true;
      product_add[_item] = $('div.trapoback_div').find('.'+variant_option).val();
      // _appendid += product_add[_item] +',';
      _mainitem += "Trapo Back";
      index < _length ? _mainitem += ',' : _mainitem = _mainitem;
    }
    else if (_item == 'warranty') {
      var _ = checkWarranty($(this));
      _appendid += _.val() +',';
      _mainitem += "Warranty";
      _warrantyprice = _.data('pricing'); // warranty price for breakdown price at cart page
      index < _length ? _mainitem += ',' : _mainitem = _mainitem;
    }
    // else if (_item == 'classic_plus'){
    //   product_add[_item] = $(this).data('id');
    //   _appendid += product_add[_item] +',';
    //   _mainitem += "Classic Plus";
    //   index < _length ? _mainitem += ',' : _mainitem = _mainitem;
    // }
  })

  console.log(product_add);
  // Need to pass in a new params where if Trapo fix or Warranty is purchase
  buildParamsAndAdd(product_add, _appendid, _steps, _mainitem, _trapofixprice,_trapoecoprice, _warrantyprice, _classicplusprice, _trapofix_vtitle, _classicplus_vtitle);
}

buildConfirmation = () => {
  $('.combo_addons img.selected').each(function(){
     var $this = $(this);
     var _item = $this.data('item');

     if (_item == 'warranty') {
       var _ = checkWarranty($this);
       product_confirm['Warranty'] = _.data('title');
       product_confirmation_price['Warranty'] = _.data('pricing');
     }
     else if (_item == 'trapo_back') {
       product_confirm['Trapo Back'] = $this.data('ptitle') + " " + $this.data('title');
       product_confirmation_price['Trapo Back'] = $this.data('pricing');
     }
     else if (_item == 'classic_plus') {
       product_confirm['Classic Plus'] = $this.data('ptitle');
       product_confirmation_price['Classic Plus'] =$this.data('pricing');
     }
  })

  if ($('.trapofix-swatch.selected').length != 0) {
    product_confirm['Trapo Fix']=$('.trapofix-swatch.selected').data('title');
    product_confirmation_price['Trapo Fix'] =$('.trapofix-swatch.selected').data('pricing');
  }

  var _ = '<div class="p-l-10 p-r-10 p-t-10 p-b-10">';
  var _checktype = $('#js_product_type').val();

  // Cart page addons to skip or not
  if (_checktype.includes('trapo hex')) {
    product_confirm['Classic Plus'] = "skip";
    product_confirm['Trapo Fix'] = "Included";
    product_confirm['Warranty'] = "Included";
  }
  else if (_checktype.includes('trapo eco')) {
    product_confirm['Classic Plus'] = "skip";
    product_confirm['Trapo Fix'] = "skip";
    product_confirm['Warranty'] = "skip";
  }
  else if (_checktype.includes('trapo back')) {
    product_confirm['Trapo Fix'] = "skip";
    product_confirm['Trapo Back'] = "skip";
    product_confirm['Classic Plus'] = "skip";
  }

  for (var key in product_confirm) {
    // check if the property/key is defined in the object itself, not in parent
    if (product_confirm.hasOwnProperty(key) ) {
      if (key == 'Title') {
        // split the name
        var b = $('.footer-pricing .customise_money').data('pricing');
        if (_checktype.includes('trapo back')) {
          var _s = product_confirm[key].split('/');
          _ += "<div class='m-b-15'><span class='m-fontSize-12 fontSize-s border-bottom-white m-b-10 m-t-20'>Mat Customisation</span><br><p class='m-b-0 m-t-10'>Base Colour: "+_s[0].trim()+"</p><p class='half-width inline m-b-0'>Lining Colour: "+_s[1].trim()+"</p><p class='half-width inline m-b-0'>"+b+"</p></div><span class='m-fontSize-12 fontSize-m border-bottom-white m-b-10 m-t-20' style='display: block; width: 24%;'>Add Ons</span>"
        }
        else {
          var _s = product_confirm[key].split('/');
          _ += "<div class='m-b-15'><span class='m-fontSize-12 fontSize-s border-bottom-white m-b-10 m-t-20'>Mat Customisation</span><br><p class='m-b-0 m-t-10'>Base Colour: "+_s[0].trim()+"</p><p class='m-b-0'>Transmission: "+_s[1].trim()+"</p><p class='m-b-0 half-width inline'>Lining Colour: "+_s[2].trim()+"</p><p class='half-width inline m-b-0'>"+b+"</p></div><span class='m-fontSize-12 fontSize-m border-bottom-white m-b-10 m-t-20' style='display: block; width: 24%;'>Add Ons</span>"
        }


      }
      else{
        if (product_confirm[key] != 'skip') {
          if (product_confirm[key] == 'Included') {
            product_confirm[key] != "" ? _ += "<span>"+key+": Included</span><br>" : _ += "<span>"+key+": No</span><br>"
          }
          else{
            var $pp = product_confirmation_price[key] != "" ? "<span class='half-width inline'>"+product_confirmation_price[key]+"</span>" : "";
            product_confirm[key] != "" ? _ += "<span class='half-width inline'>"+key+": Yes </span>"+$pp+"<br>" : _ += "<span>"+key+": No</span><br>"
          }

        }
      }

    }
  }

  _+= "<span class='m-fontSize-12 fontSize-m m-b-10 m-t-20' style='display: block; width: 100%;'>SKU: "+ _sku +"</span></div>";
  $('.confirmation_product').empty();
  $('.confirmation_product').html(_);
  resetProductConfirm();
}
resetProductConfirm = () => {
  product_confirm['Trapo Back'] = "";
  product_confirm['Classic Plus'] = "";
  product_confirm['Trapo Fix'] = "";
  product_confirm['Warranty'] = "";
}

variantTitle = (va) => {
  product_confirm['Title'] = va.title;
  product_add['vid'] = va.id;
  _sku = va.sku;
  var _template = $('#js_template').val();
  if (_template.includes('product.mat') || _template.includes('product.eco') || _template.includes('product.hex')) {
    variant_option = va.option1.toLowerCase() + '-' + va.option2.toLowerCase();
  }

  if (_template.includes('product.mat') || _template.includes('product.back') || _template.includes('product.hex') || _template.includes('product.eco')) {
    retrieve360(va);
  }
}

showBagianKarpetandTransmission = (v) => {
  // console.log(v);

  $('.combo_addons img.selected').removeClass('selected');
  $('.trapofix-swatch.selected').removeClass('selected');
  $('.classic-plus-swatch.selected').removeClass('selected');

  var _bagiankarpet = v.option3;
  var _transmission = $('#transmission').val();
  var isEuropean = $('.bagian_karpet_info').data('european');
  var noBack = $('.new-info').data('noback');
  // console.log('answer here', _bagiankarpet, _transmission, isEuropean, noBack);
  $('.transmission_info').text(_transmission);
  $('.bagian_karpet_info').text(_bagiankarpet);


  // Run disabled at classic plus or trapo
  $('.classic-plus-swatch').each(function(){
    var _available = $(this).data('available');
    // console.log('classic plus leh', _available);
    _available == true ? $(this).removeClass('disabled') : $(this).addClass('disabled');
  })

  $('.trapofix-swatch').each(function(){
    var _available = $(this).data('available');
    _available == true ? $(this).removeClass('disabled') : $(this).addClass('disabled');
  })

  if (_bagiankarpet == "Pengemudi Saja") {
    if (!noBack) {
      skipTrapoBack(true);
    }

    $(".classic-plus-1-baris").addClass('disabled');
    $(".classic-plus-2-baris").addClass('disabled');

    if (isEuropean) {
      $(".trapofix-swatch").addClass('disabled');
    }
    else {
      $(".trapofix-swatch").addClass('disabled');
      $(".trapofix-pengemudi-saja").removeClass('disabled');
    }
  }
  else if (_bagiankarpet == "Baris 1 & 2") {
    if (!noBack) {
      skipTrapoBack(true);
    }
    if (isEuropean) {
      $(".trapofix-swatch").addClass('disabled');
    }
    else {
      $(".trapofix-swatch").addClass('disabled');
      $(".trapofix-pengemudi-saja").removeClass('disabled');
      $(".trapofix-1-baris").removeClass('disabled');
      $(".trapofix-2-baris").removeClass('disabled');
    }
  }
  else if (_bagiankarpet == "Bagasi Saja") {
    if (!noBack) {
      skipTrapoBack(true);
    }
    $(".classic-plus-pengemudi-saja").addClass('disabled');
    $(".classic-plus-1-baris").addClass('disabled');
    $(".classic-plus-2-baris").addClass('disabled');

    if (isEuropean) {
      $(".trapofix-swatch").addClass('disabled');
      $(".trapofix-bagasi-saja").removeClass('disabled');
    }
    else {
      $(".trapofix-swatch").addClass('disabled');
      $(".trapofix-bagasi-saja").removeClass('disabled');
    }
  }
  else if (_bagiankarpet == "Full Set") {
    if (!noBack) {
      skipTrapoBack(false);
    }
    if (isEuropean) {
      $(".trapofix-swatch").addClass('disabled');
      $(".trapofix-bagasi-saja").removeClass('disabled');
    }
    else {
      $(".trapofix-swatch").removeClass('disabled');
    }
  }

}

skipTrapoBack = (boo) => {
  if (boo == true) {
    $('#step2').hide();
    $('.progress-step').css('width', '50%');
    $(".next_button").attr('onclick', "nextPrevStep('classic-plus')");
    $('.classic-plus .is-previous').attr('onclick', "nextPrevStep('product_form_step')");
  }
  else{
    $('#step2').show();
    $('.progress-step').css('width', '33%');
    $(".next_button").attr('onclick', "nextPrevStep('trapo-back')");
    $('.classic-plus .is-previous').attr('onclick', "nextPrevStep('trapo-back')");
  }
}

changeTransmissionExtraInfo = (evt) => {
  var $this = $(evt);
  $(".transmission_info").text($this.val());
}

retrieve360 = (selected_variant) => {
  $('.turntable-360').empty();
  var _type = $('#js_product_type').val();
  var _template = $('#js_template').val();
  if (_template.includes('product.back')) {
    var combine_variant = selected_variant.option1.toLowerCase() + '_' +selected_variant.option2.toLowerCase();
  }
  else {

    var _handleize = selected_variant.option3.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');

    _handleize = _handleize.replace(/-/g, '_');

    var combine_variant = selected_variant.option1.toLowerCase() + '_' +selected_variant.option2.toLowerCase() + '_all' ;
  }


  console.log(combine_variant);
  var _html = '';
  $('.'+combine_variant).children().each(function(){
    var _this = $(this);
    _html+= '<li data-img-src="http:'+ _this.val() +'"></li>';
  })

  $('.turntable-360').html(_html);

  $('#myTurnTable').turntable({
    axis: 'x, y, or scroll',
    reverse: true,
    scrollStart: 'top, middle, or bottom' // only necessary if axis = 'scroll'
  });

}

buildParamsAndAdd = (product_add, line_item_allvid, step, mainitem, trapofix_price,trapoeco_price, warranty_price, classicplus_price,trapofix_vtitle, classicplus_title) => {
  var params = [];

  for (var property in product_add) {
    if (product_add.hasOwnProperty(property)) {
        var _property = {};
        if (property == 'trapo_back') {
          _property['combo'] = 'yes';
        }
        else if (property == 'vid') {
          _property['bundle'] = line_item_allvid;
          _property['Bundle Product'] = mainitem;
          _property['Final Price'] = $('.sticky-price .customise_money .money').text();

          // Include trapofix / warranty pricing
          _property['Trapo Fix Price'] = trapofix_price ;
          _property['Trapo Eco Price'] = trapoeco_price ;
          _property['Trapo Fix Title'] = trapofix_vtitle ;
          _property['Warranty Price'] = warranty_price ;
          _property['Classic Plus Price'] = classicplus_price ;
          _property['Classic Plus Title'] = classicplus_title ;

          // Trapo back id
          _property['Trapo BackID'] = product_add['trapo_back'];

          // If trapoback classic then add is trapo back main classic
          _property['PVC'] = $('.pvc-swatch.selected').attr('data-value');
          _property['TEXTURE'] = $('.texture-swatch.selected').attr('data-value');

        }

        _property['Transmission'] = $('#transmission').val();

        if (product_add[property] != "") {
          params.push(
            {
              'id' : product_add[property],
              'qty': 1,
              'properties': _property
            }
          )
        }

    }
  }

  console.log('params', params);
  MGUtil.begin(params);
  setTimeout(() => {
    // ajaxRefreshCart();
    $('.combo_addons img.selected').removeClass('selected');
    $('.trapofix-swatch.selected').removeClass('selected');
  $('.trapoeco-swatch.selected').removeClass('selected');
    $('.classic-plus-swatch.selected').removeClass('selected');
    $('.firstStep').show();
    $('.'+step).hide();
    window.location.href = "/cart";
  }, 2000);

}

checkWarranty = (ele) => {
  var _type = ele.data('type')
  var _checktype = $('#js_product_type').val();

  if (_checktype.includes('trapo back')) {
    product_add['warranty'] = $('.back').val();
    return $('.back');
  }
  else{
    if (buyTrapoBack && _type == 'trapo-classic' ) {
      product_add['warranty'] = $('.classic-back').val();
      return $('.classic-back');
    }
    else if(buyTrapoBack==false && _type == 'trapo-classic' ){
      product_add['warranty'] = $('.classic').val();
      return $('.classic');
    }

    if (buyTrapoBack && _type == 'trapo-back') {
      product_add['warranty'] = $('.back').val();
      return $('.back');
    }
  }

}

removeSingleProduct = (ele) => {
  $this = $(ele);
  CartJS.removeItemById($this.data('id'));
  setTimeout(() => location.reload(), 1000);
}

priceChanges = (va) =>{
  var compare_at_price = va.compare_at_price;
  if (va.compare_at_price == null) {
    $('.package_was_price').text('');
  }else {
    $('.package_was_price').text(Shopify.formatMoney(va.compare_at_price, $('body').data('money-format')));
  }
}

changetabs = (evt) =>{
  var $this = $('.jsc-menu-tabs');
  var dataTabs = $(evt).attr('data-tabs');

  $this.each(function(){
    var $dataTabs = $(this).attr('data-tabs');

      if ($dataTabs == dataTabs) {
        $(this).addClass('isactive');
      }else {
        $(this).removeClass('isactive');
      }
   });

   if (dataTabs == "description") {
     $('.jsc-description').show();
     $('.jsc-faq').hide();
     $('.jsc-bundle').hide();
   }
   if (dataTabs == "faq") {
     $('.jsc-description').hide();
     $('.jsc-faq').show();
     $('.jsc-bundle').hide();
   }
   if (dataTabs == "bundles") {
     $('.jsc-description').hide();
     $('.jsc-faq').hide();
     $('.jsc-bundle').show();
   }

}